import { useState } from 'react';
import { faqItems } from '@/mocks/articles';

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <section className="py-16 md:py-20 px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <span className="text-xs font-medium text-secondary-600 bg-secondary-100 px-3 py-1 rounded-full">
              常见问题
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-3">
              关于缘之空 · 你想知道的
            </h2>
          </div>

          <div className="flex flex-col gap-3">
            {faqItems.map((item, idx) => (
              <div
                key={idx}
                className="bg-background-50 border border-background-200 rounded-lg overflow-hidden transition-colors"
              >
                <button
                  onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                >
                  <span className="font-medium text-foreground-900 text-sm pr-4">
                    {item.question}
                  </span>
                  <div className={`w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full transition-colors ${
                    openIdx === idx ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'
                  }`}>
                    <i className={openIdx === idx ? 'ri-subtract-line text-sm' : 'ri-add-line text-sm'}></i>
                  </div>
                </button>
                {openIdx === idx && (
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}